import { render, staticRenderFns } from "./classDishWrapper.vue?vue&type=template&id=48f7b8bc&scoped=true&"
import script from "./classDishWrapper.vue?vue&type=script&lang=js&"
export * from "./classDishWrapper.vue?vue&type=script&lang=js&"
import style0 from "./classDishWrapper.vue?vue&type=style&index=0&id=48f7b8bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f7b8bc",
  null
  
)

export default component.exports